import { render, staticRenderFns } from "./AddEditModifier.vue?vue&type=template&id=3fb82816&scoped=true&"
import script from "./AddEditModifier.vue?vue&type=script&lang=ts&"
export * from "./AddEditModifier.vue?vue&type=script&lang=ts&"
import style0 from "./AddEditModifier.vue?vue&type=style&index=0&id=3fb82816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb82816",
  null
  
)

export default component.exports